import React from 'react'
import styles from './styles.module.scss'

const EnrollYears = ({ years, activeSyid, onChange }) => {
  if (!years?.length) return null

  return (
    <div className={styles.enrollYears}>
      <span className={styles.label}>Год набора:</span>
      <div className={styles.list}>
        {years.map(({ syid, name }) => (
          <button
            key={syid}
            type="button"
            className={`${styles.year} ${syid === activeSyid ? styles.active : ''}`}
            onClick={() => onChange(syid)}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default EnrollYears
